export class Container{
  constructor() {
    constructor(this);
  }

  find(lambda, lookInSubcontainers = false){
    return find.call(this, lambda, lookInSubcontainers);
  }

  findByTag(tag, lookInSubcontainers = false){
    return this.find((serviceConfig) => serviceConfig.tags.includes(tag), lookInSubcontainers);
  }
}

function find(lambda, lookInSubcontainers = false, __results = []){
  if (!this.__initiated)
    throw new Error('Container not yet initiated');

  for (let key in this){
    if (Object.prototype.hasOwnProperty.call(this.__config, key)){
      if (lambda.call(this, this.__config[key]))
        __results.push(this[key]);
    }
  }

  if (lookInSubcontainers)
    for (let key in this.__subContainers){
      if (Object.prototype.hasOwnProperty.call(this.__subContainers, key))
        this.__subContainers[key].find(lambda, lookInSubcontainers, __results);
    }

  return __results;
}

export const constructor = function(obj){
  obj.__initiated = false;
  obj.__config = {};
  obj.__subContainers = {};
};

export const forbiddenKeys = [
  '__initiated',
  '__config',
  '__subContainers',
  'find',
  'findByTag'
];